var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { useSetRecoilState } from 'recoil';
import { Translate } from "../../I18N";
import { notificationAtom } from "../atoms";







const getData = async (res) => res.json ? res.json() : res;
const getError = async (res) => {
  const json = res.json ? await res.json() : undefined;
  return json && json.error ? json.error : new Error('An error occurred');
};

const useApiCaller = () => {
  const setNotifications = useSetRecoilState(notificationAtom);

  const handleSuccess = async (res, successMessageComponent) => {
    setNotifications({
      type: 'success',
      text: successMessageComponent
    });
    return getData(res);
  };

  const handleError = async (e) => {var _e$json;
    setNotifications({
      type: 'error',
      text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
      details: (_e$json = e.json) !== null && _e$json !== void 0 && _e$json.prettyMessage ? /*#__PURE__*/_jsx("span", {}, void 0, e.json.prettyMessage) : undefined
    });
    return e.message;
  };

  const requestAction = async (
  action,
  requestParams,
  successMessageComponent) =>
  {
    let data;
    let error;
    try {
      const res = await action(requestParams);
      if (!res.status || res.status === 200) {
        data = handleSuccess(res, successMessageComponent);
      } else {
        error = handleError(await getError(res));
      }
    } catch (e) {
      error = handleError(e);
    }
    const result1 = { data, error: Promise.resolve(error) };
    return result1;
  };

  return { requestAction };
};


export { useApiCaller };